import Api from 'api'

const config = {
  baseURL: '/api/app/v1/user',
}
const api = new Api(config)

api.setNewPassword = ({ ...rest }) => api.put('/password', { ...rest })

api.deleteAdmitadAccount = () => api.delete('/accounts/admitad')

api.fetchAll = () => api.get('/accounts')

api.fetchById = ({ id }) => api.get(`/accounts/${id}`)

api.check2FA = () => api.get('/2fa')
api.enable2FA = ({ ...rest }) => api.post('/2fa/enable', { ...rest })
api.disable2FA = ({ ...rest }) => api.delete('/2fa', { ...rest })
api.init2FA = () => api.post('/2fa/init')

api.fetchUser = () => api.get('')
api.updateUser = ({ ...rest }) => api.patch('', { ...rest })

api.getUserInfo = () => api.get('')

export default api
